// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"projectquote-module--contentContainer--3lygs","quote":"projectquote-module--quote--3VYxf","author":"projectquote-module--author--1sP5D"};